// Vermillion square chop with an inset white border, slightly rotated. Same
// visual as a real Chinese seal stamp. Used on swipe cards, match modal,
// flashcards, and library CTAs. The character is passed in; common choices
// are 字, 缘, 福.

import { C } from '@/styles/tokens';

interface SealStampProps {
  /** Character(s) inside the chop. Single character reads best. */
  char: string;
  /** Edge length in px. Default 38. */
  size?: number;
  /** Degrees of rotation. Default -6 (slight counter-clockwise). */
  rotate?: number;
  /** Override the chop color (defaults to vermillion). */
  color?: string;
  /** Extra classes for positioning. */
  className?: string;
}

export function SealStamp({
  char,
  size = 38,
  rotate = -6,
  color = C.vermillion,
  className = '',
}: SealStampProps) {
  return (
    <span
      aria-hidden
      className={`inline-flex items-center justify-center select-none ${className}`}
      style={{
        width: size,
        height: size,
        background: color,
        color: 'white',
        fontFamily: 'var(--zm-font-zh-serif, "Noto Serif SC", "Songti SC", serif)',
        fontWeight: 900,
        fontSize: Math.round(size * 0.55),
        borderRadius: Math.round(size * 0.14),
        transform: `rotate(${rotate}deg)`,
        boxShadow: `0 4px 12px ${color}55, inset 0 0 0 2px rgba(255,255,255,0.85)`,
        lineHeight: 1,
        letterSpacing: '-0.02em',
      }}
    >
      {char}
    </span>
  );
}
